
<form [formGroup]="importDealForm" (ngSubmit)="importDealKey()">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Import DART Deal</h4>
        <button class="close" type="button" (click)="close()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <success></success>
        <div *ngIf="processing">
          <md-spinner-block></md-spinner-block>
        </div>
        <div class="form-group">
          <label for="dealKey">DART Deal(s) key(s)</label><small style="float:right">separated by commas*</small>
          <input class="form-control" id="dealKey" type="text" formControlName="dartDealKey" name="dealKey" [disabled]="processing">
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="submit" [disabled]="processing">Import</button>
        <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
      </div>
    </div>
  </div>
</form>